<template>
    <div class="mVideoN-container" v-observe-visibility="startAnimate">
        <div class="mVideoN-logo">
            <img class="logo_video_no" :src="logo_red" alt="Nueva Tecate 0.0, perfecta para disfrutar con tus comidas favoritas">
        </div>
        <div class="videoNoContainer" :class="{onlySafari: isSafari}">
            <div class="containerNo" :class="{onlySafari: isSafari}" id="videono" style="border-radius: 10px; "></div>
        </div>
        <div class="mVideoN-button">
            <a href="" class="no-button" @click="onHome()">
                <span>Ir al sitio</span>
            </a>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import Bowser from "bowser";
import logo_red from "@/assets/TECATELOGO_ROJO.png";
import tagFunctions from '@/utils/tagFunctions.js';
import YouTubePlayer from 'youtube-player';

let timer, percent = 0, quartileTime, duration

export default {
    name: "VideoN",
    data() {
        return {
            animate: false,
            isSafari: false,
            logo_red,
            videono: null,
        };
    },
    computed: {
        ...mapGetters(["isLoaded"]),
    },
    methods: {
        startAnimate(isVisible) {
            if(isVisible) {
                this.animate=true
            }
        },
        record(event) {
            let currentTime = Math.round(event.target.getCurrentTime());
            percent = getPercent(event);
            if (currentTime == quartileTime) {
                tagFunctions.evVideoPush(
                event.target.getVideoData().title,
                "Reach",
                "25",
                duration
                );
            }
            if (currentTime == 2 * quartileTime) {
                tagFunctions.evVideoPush(
                event.target.getVideoData().title,
                "Reach",
                "50",
                duration
                );
            }
            if (currentTime == 3 * quartileTime) {
                tagFunctions.evVideoPush(
                event.target.getVideoData().title,
                "Reach",
                "75",
                duration
                );
            }
            if (currentTime == Math.round(event.target.getDuration() * 0.99)) {
                tagFunctions.evVideoPush(
                event.target.getVideoData().title,
                "Reach",
                "100",
                duration
                );
            }
            function getPercent(event) {
                return Math.round(
                (event.target.getCurrentTime() / event.target.getDuration()) * 100
                );
            }
        },
        onPlayerStateChange(event) {
            duration = event.target.getDuration();
            quartileTime = Math.round(event.target.getDuration() / 4);
            const getQuartile = () => {
                if (percent <= 25) return 25;
                else if (percent > 25 && percent <= 50) return 50;
                else if (percent > 50 && percent <= 75) return 75;
                else return 100;
            };
            if (event.data == window.YT.PlayerState.PLAYING) {
                tagFunctions.evVideoPush(event.target.getVideoData().title, "Play", getQuartile(), duration)
                tagFunctions.user_interactionPush('click', 'play :: Tecate 0.0 | Cero  Cero pretextos para disfrutar más tus comidas', 'video no')
                timer = setInterval(() => {
                    this.record(event);
                }, 1000);
            } else {
                clearInterval(timer);
            }
            if (event.data == window.YT.PlayerState.ENDED) {
                tagFunctions.evVideoPush(event.target.getVideoData().title, "Complete", getQuartile(), duration)
                tagFunctions.user_interactionPush('click', 'complete :: Tecate 0.0 | Cero  Cero pretextos para disfrutar más tus comidas', 'video no')
             }
            if (event.data == window.YT.PlayerState.PAUSED) {
                tagFunctions.evVideoPush(event.target.getVideoData().title, "Pause", getQuartile(), duration)
                tagFunctions.user_interactionPush('click', 'pause :: Tecate 0.0 | Cero  Cero pretextos para disfrutar más tus comidas', 'video no')
            }
        },
        onHome() {
            this.$router.push({ path: "/producto" });
        }
    },
    components: {},
    mounted() {
        this.videono = YouTubePlayer('videono', {videoId: 'Cf5kmqqM4f0'})
        this.videono.on('stateChange', this.onPlayerStateChange)
    },
    beforeMount() {
        const browser = Bowser.getParser(window.navigator.userAgent);
        if (browser.getBrowserName()=='Safari') {
            this.isSafari = true
        }
    }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/VideoN.scss";
</style>

<style lang="scss">
.containerNo {
    //width: 25.5vw !important;
    width: calc(100vh * 9/16) !important;
    height: 100vh;
    &.onlySafari {
        //height: 80vh;
        //height: calc(21.5vw * 16/9);
        //width: 21.5vw !important;
        width: calc(69vh * 9/16) !important;
        height: 69vh;
    }
}
@media screen and (max-width: 768px) {
    .containerNo {
        //width: 72vw !important;
        width: calc(63vh * 9/16) !important;
        height: 63vh;
        &.onlySafari {
            height: 72vh;
            //width: 72vw !important;
            width: calc(72vh * 9/16) !important;
        }
    }  
}
@media screen and (min-width: 820px) and (max-width: 1180px) {
    .containerNo {
        //width: 51vw !important;
        width: calc(63vh * 9/16) !important;
        height: 63vh;
        &.onlySafari {
            height: 72vh;
            //width: 72vw !important;
            width: calc(72vh * 9/16) !important;
        }
    }
}
</style>